import { render, staticRenderFns } from "./ModalLabelProductsByOrder.vue?vue&type=template&id=55fcc3d0&lang=pug&"
import script from "./ModalLabelProductsByOrder.vue?vue&type=script&lang=js&"
export * from "./ModalLabelProductsByOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports